import { CLEAR_MODAL_DATA, HIDE_MODAL, SHOW_MODAL, SHOW_MODAL_ERROR } from "./constants";

import produce from "immer";

// The initial state of this store.
const initialState = {
    show: false,
    theme: null,
    data: {},
};

export default produce((state, action) => {
    switch (action.type) {
        case SHOW_MODAL:
            state.show = true;
            state.theme = action.theme;
            state.data = action.data;
            break;
        case SHOW_MODAL_ERROR:
            state.show = false;
            state.theme = null;
            state.data = {};
            break;
        case HIDE_MODAL:
            state.show = false;
            break;
        case CLEAR_MODAL_DATA:
            state.theme = null;
            state.data = {};
            break;
        default:
            break;
    }
}, initialState);
